<template>
  <v-card flat class="pa-3 mt-1">
    <!-- Blocage affiché si activé par le manager -->
      <v-alert
    v-if="blocked"
    type="error"
    prominent
    border="left"
    icon="mdi-alert-circle-outline"
    class="mb-4"
  >
    {{ blockReason || "Oops… this service is currently unavailable. Please try again later." }}
  </v-alert>
    <v-card-title class="d-flex align-center justify-center py-0">
      <div class="d-flex align-center">
        <v-img
          :src="require(`@/assets/images/logos/logo.png`)"
          max-width="300px"
          alt="logo"
          contain
          class="me-0"
        ></v-img>
      </div>
    </v-card-title>

    <v-form class="multi-col-validation" :disabled="blocked">
      <v-card-text class="pt-1">
        <p class="text-h6 text-center">Make a Deposit</p>
        <input type="hidden" v-model="payment_ref" ref="payment_ref" id="payment_ref">
        <v-row>
          <v-col cols="10" class="py-0 my-1">
            <v-text-field
              v-model="userName"
              ref="userName"
              outlined dense
              label="Search username, phone number, unique code..."
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="py-0 my-1">
            <v-btn
              color="success"
              class="me-3"
              fab small
              @click="getUsers()"
            >
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
            </v-btn>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-select
              v-model="selectedUser"
              ref="selectedUser"
              :items="users"
              item-text="username"
              item-value="id"
              outlined dense
              label="Select a user"
              @change="getUserDetails()"
            ></v-select>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-text-field
              v-model="phoneNumber"
              ref="phoneNumber"
              outlined
              dense
              label="User Phone Number"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-select
              v-model="selectedLoanCampaign"
              ref="selectedLoanCampaign"
              outlined return-object
              dense
              :items="loans_campaigns"
              item-text="loan_campaign_name"
              item-value="id"
              label="Select Loan/Campaign"
            ></v-select>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-text-field
              v-model="amount"
              ref="amount"
              outlined
              dense
              label="Amount"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-text-field
              v-model="currentPassword"
              ref="currentPassword"
              :type="isCurrentPasswordVisible ? 'text' : 'password'"
              :append-icon="isCurrentPasswordVisible ? mdiEyeOffOutline : mdiEyeOutline"
              label="Input Current Password"
              outlined
              dense
              @click:append="isCurrentPasswordVisible = !isCurrentPasswordVisible"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-checkbox label="Send SMS to Client containing campaign status, completion rate, deposited amount, date and topup" hide-details class="me-3 mt-1"></v-checkbox>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-checkbox label="Send Email to Client" hide-details class="me-3 mt-1"></v-checkbox>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-checkbox label="Send Notification to Client" hide-details class="me-3 mt-1"></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="text-end">
        <spinner v-if="loading" class="text-end"></spinner>
        <v-btn
          v-else
          color="primary"
          class="me-3 mt-3"
          :disabled="blocked"
          @click="depositMoneyCampaign()"
        >
          Deposit
        </v-btn>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import { mdiKeyOutline, mdiLockOpenOutline, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import axios from 'axios'
import Spinner from "@/components/Spinner.vue";

export default {
  components: {
    Spinner,
  },

  data() {
    return {
      // Block status
      blocked: false,
      blockReason: '',

      loading: false,
      userName: "",
      selectedUser: "",
      phoneNumber: "",
      selectedLoanCampaign: null,
      isCurrentPasswordVisible: false,
      currentPassword: "",
      amount: "",
      payment_ref: "",
      users: [],
      loans_campaigns: [],

      mdiKeyOutline,
      mdiLockOpenOutline,
      mdiEyeOffOutline,
      mdiEyeOutline,
    }
  },

  async mounted() {
    await this.checkDepositBlock()
    if (!this.blocked) {
      this.getDepositPaymentRef()
    }
    document.title = "TopUp: Savings | Deposit into Campaign"
  },

  methods: {
    async checkDepositBlock() {
      try {
        const res = await axios.get('/api/v1/topup/deposit/block-status/')
        this.blocked = res.data.blocked
        this.blockReason = res.data.reason
        if (this.blocked) {
          this.$store.commit('setSnackBarMessage', 'You can’t make deposits right now. Please try again later..')
          this.$store.commit('setSnackBarColor', 'red darken-4')
          this.$store.commit('activateSnackBar', true)
        }
      } catch (error) {
        console.error('Failed to check deposit block status', error)
        this.blocked = false
      }
    },

    getUsers() {
      axios
        .get('/api/v1/topup/get/clients/' + this.userName + '/')
        .then(response => {
          this.users = response.data
          console.log(this.users)
        })
        .catch(error => {
          if (error.response) {
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          } else {
            this.$store.commit('setSnackBarMessage', "An error occurred, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        })
    },

    getUserDetails() {
      axios
        .get('/api/v1/topup/get/client/information/' + this.selectedUser + '/')
        .then(response => {
          console.log(response.data)
          this.phoneNumber = response.data['phone_number']
          this.loans_campaigns = response.data['loans_campaigns']
        })
        .catch(error => {
          if (error.response) {
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          } else {
            this.$store.commit('setSnackBarMessage', "An error occurred, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        })
    },

    async getDepositPaymentRef() {
      await axios
        .get('/api/v1/topup/create/user/deposits/payment_ref/')
        .then(response => {
          this.payment_ref = response.data
          console.log(this.payment_ref)
        })
        .catch(error => {
          if (error.response) {
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          } else {
            this.$store.commit('setSnackBarMessage', "An error occurred, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        })
    },

    async depositMoneyCampaign() {
      if (this.payment_ref === "") {
        this.$store.commit('setSnackBarMessage', "An error occurred with transaction, your reference code is null.")
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
        window.location.reload()
      } else if (!this.selectedLoanCampaign) {
        this.$store.commit('setSnackBarMessage', "Please select the client's campaign")
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
        this.$refs.selectedLoanCampaign.focus()
      } else if (this.amount === "" || String(Number(this.amount)) === "NaN") {
        if (this.amount === "") {
          this.$store.commit('setSnackBarMessage', "Please input the amount")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.amount.focus()
        } else {
          this.$store.commit('setSnackBarMessage', "Please input only numbers for the amount")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.amount.focus()
        }
      } else if (this.currentPassword === "") {
        this.$store.commit('setSnackBarMessage', "Please input your password.")
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
      } else {
        this.loading = true

        let formData = new FormData()
        if (this.selectedLoanCampaign["loan_campaign_name"].includes("Loan:")) {
          formData.append('loan', this.selectedLoanCampaign["id"])
          formData.append('payment_ref', this.payment_ref)
          formData.append('amount', this.amount)
          formData.append('password', this.currentPassword)
        } else if (this.selectedLoanCampaign.loan_campaign_name.includes("Campaign:")) {
          formData.append('campaign', this.selectedLoanCampaign["id"])
          formData.append('payment_ref', this.payment_ref)
          formData.append('amount', this.amount)
          formData.append('password', this.currentPassword)
        }

        await axios
          .post('/api/v1/topup/deposits/', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            console.log(this.payment_ref, response.data)
            this.$store.commit('setSnackBarMessage', response.data[0].text)
            this.$store.commit('setSnackBarColor', response.data[0].color)
            this.$store.commit('activateSnackBar', true)
            this.$store.commit('setSnackBarTimeOut', 8000)

            if (response.data[0].category === "success") {
              let router = this.$router
              setTimeout(function () {
                router.push('/savings/transactions')
              }, 4000)
            }
          })
          .catch(error => {
            if (error.response) {
              this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
              this.$store.commit('setSnackBarColor', "red darken-4")
              this.$store.commit('activateSnackBar', true)
            } else {
              this.$store.commit('setSnackBarMessage', "An error occurred, please check your internet connection and try again later.")
              this.$store.commit('setSnackBarColor', "red darken-4")
              this.$store.commit('activateSnackBar', true)
            }
          })

        this.loading = false
      }
    },
  },
}
</script>
